export enum IconName {
    ALERT = 'alert',
    BAND_AID = 'band-aid',
    CALENDAR = 'calendar',
    CHANGE = 'change',
    CHAT = 'chat',
    CHECK = 'check',
    CIRCLE_CHECK = 'circle-check',
    CIRCLE_CHECK_FILLED = 'circle-check-filled',
    CIRCLE_CLOCK = 'circle-clock',
    CIRCLE_INFO = 'circle-info',
    CIRCLE_MINUS = 'circle-minus',
    CIRCLE_OBS = 'circle-obs',
    CIRCLE_OBS_FILLED = 'circle-obs-filled',
    CIRCLE_PLUS = 'circle-plus',
    CIRCLE_WARNING = 'circle-warning',
    CLOCK = 'clock',
    CLOSE = 'close',
    CREDIT_CARD = 'credit-card',
    DELETE = 'delete',
    DOC = 'doc',
    DOCUMENTS = 'documents',
    DOC_INBOUND = 'doc-inbound',
    DOC_INTERNAL = 'doc-internal',
    DOC_OUTBOUND = 'doc-outbound',
    DOWN = 'down',
    DOWNLOAD = 'download',
    EDIT = 'edit',
    EQUALS = 'equals',
    EXTERNAL = 'external',
    GEAR = 'gear',
    GLOBE = 'globe',
    GRAPH = 'graph',
    HEART = 'heart',
    HOME = 'home',
    HOUSE = 'house',
    LEFT = 'left',
    LOCK_CREDIT_CARD = 'lock-credit-card',
    LOGIN = 'login',
    LOGIN_REQUIRED = 'login-required',
    LOGOUT = 'logout',
    MAIL = 'mail',
    MENU = 'menu',
    MINUS = 'minus',
    OPTIONS = 'options',
    PDF = 'pdf',
    PHONE = 'phone',
    PIGGY_BANK = 'piggy-bank',
    PIN = 'pin',
    PIN_CODE = 'pin-code',
    PLANT = 'plant',
    PLUS = 'plus',
    PPT = 'ppt',
    PRINT = 'print',
    PROFILE = 'profile',
    PROFILE_FILLED = 'profile-filled',
    PROFILE_OUTLINE = 'profile-outline',
    RIGHT = 'right',
    RIGHT_ARROW = 'right-arrow',
    LEFT_ARROW = 'left-arrow',
    SEARCH = 'search',
    STAR = 'star',
    STAR_FILLED = 'star-filled',
    TRANSFER = 'transfer',
    UMBRELLA = 'umbrella',
    UP = 'up',
    UPLOAD = 'upload',
    WALLET = 'wallet',
    ZIP = 'zip',
    POWERBI = 'powerbi',
    HORIZONTAL_BAR_CHART = 'horizontalbarchart',
}

export enum BankOgSparing {
    BANKID = 'bankid',
    BRUKSKONTO = 'brukskonto',
    BSU = 'bsu',
    ETISKE_INVESTERINGER = 'etiske-investeringer',
    FINANSIERINGSBEVIS = 'finansieringsbevis',
    GRAF = 'graf',
    GRAF_2 = 'graf-2',
    GRAF_3 = 'graf-3',
    KALKULATOR = 'kalkulator',
    KODEBRIKKE = 'kodebrikke',
    KONTANTER = 'kontanter',
    LAER_OM_FOND = 'laer-om-fond',
    MELLOMFINANSIERING = 'mellomfinansiering',
    MOBILBANK = 'mobilbank',
    MYNTER = 'mynter',
    OPPRETT_KONTO = 'opprett-konto',
    SPAREKONTO = 'sparekonto',
    TIMEGLASS = 'timeglass',
    TIMEGLASS2 = 'timeglass2',
    VISAKORT = 'visakort',
}

export enum Bygninger {
    BOLIG = 'bolig',
    EIENDOM = 'eiendom',
    HUS = 'hus',
    HYTTE = 'hytte',
    INDUSTRI = 'industri',
    KONTORBYGG = 'kontorbygg',
    LEILIGHET = 'leilighet',
    NATURSKADE = 'naturskade',
}

export enum Dyr {
    HEST = 'hest',
    HUND = 'hund',
    KATT = 'katt',
    SKADEDYR_OG_HUSSOPP = 'skadedyr-og-hussopp',
}

export enum HelseOgForsikring {
    BARNEFORSIKRING = 'barneforsikring',
    CAMPINGSTOL = 'campingstol',
    FLAMMER = 'flammer',
    FORSIKRING = 'forsikring',
    HJERTERYTME = 'hjerterytme',
    INNBOFORSIKRING = 'innboforsikring',
    KRITISK_SYKDOM = 'kritisk-sykdom',
    LIVSFORSIKRING = 'livsforsikring',
    NØKKEL = 'nokkel',
    PC = 'pc',
    PERSONFORSIKRING = 'personforsikring',
    REFLEKS = 'refleks',
    REISEGODS = 'reisegods',
    RETTSHJELP = 'rettshjelp',
    SENG = 'seng',
    SPEBARN = 'spebarn',
    STETOSKOP = 'stetoskop',
    SYKEUTGIFTER = 'sykeutgifter',
    TIPS = 'tips',
    UFØREFORSIKRING = 'uforeforsikring',
    ULYKKEFORSIKRING = 'ulykkeforsikring',
    VEKT = 'vekt',
    VERDIFORSIKRING = 'verdiforsikring',
}

export enum Kjøretøy {
    BIL = 'bil',
    BUSS = 'buss',
    BAAT = 'baat',
    CAMPINGVOGN = 'campingvogn',
    ELBIL = 'elbil',
    FLY = 'fly',
    MOPED = 'moped',
    MOTORSYKKEL = 'motorsykkel',
    REDNINGSBAAT = 'redningsbaat',
    SNØSCOOTER = 'snoscooter',
    SYKKEL = 'sykkel',
    TAXI = 'taxi',
    TILHENGER = 'tilhenger',
    TRAKTOR = 'traktor',
    TRIKK_OG_TOG = 'trikk-og-tog',
    VEIHJELP = 'veihjelp',
}

export enum Kommunikasjon {
    EPOST = 'epost',
    MOTTA_SMS = 'motta-sms',
    TELEFON = 'telefon',
    WIFI = 'wifi',
}

export enum Laering {
    KLASSEROM = 'klasserom',
    LAPTOP = 'laptop',
    LIVE_STREAMING = 'live-streaming',
    VIDEO = 'video',
}

export enum MatOgDrikke {
    ALKOHOL = 'alkohol',
    IS = 'is',
    KAFFEKOPP = 'kaffekopp',
    KNIV_OG_GAFFEL = 'kniv-og-gaffel',
    LUNSJPOSE = 'lunsjpose',
    TEKOPP = 'tekopp',
}

export enum Medlem {
    DAME = 'dame',
    MANN = 'mann',
    MEDLEMSRABATT = 'medlemsrabatt',
}

export enum Navigasjon {
    JORDKLODE = 'jordklode',
    NAVIGASJON = 'navigasjon',
    PIN = 'pin',
}

export enum Status {
    AVBESTILLING = 'avbestilling',
    FORSINKELSE = 'forsinkelse',
    SMILEY_GLAD = 'smiley-glad',
    SMILEY_NØYTRAL = 'smiley-noytral',
    SMILEY_TRIST = 'smiley-trist',
    TANNHJUL = 'tannhjul',
    TID = 'tid',
}

export enum Verktøy {
    LINJAL = 'linjal',
    VERKTØY = 'verktoy',
    VERKTØYKASSE = 'verktoykasse',
}

export enum Annet {
    BLINK = 'blink',
    BUKK = 'bukk',
    FEIRING = 'feiring',
    KALENDER = 'kalender',
    MOLEKYL = 'molekyl',
    PENGESPILL = 'pengespill',
    PORNOGRAFI = 'pornografi',
    SHOPPINGPOSE = 'shoppingpose',
    SOL = 'sol',
    SOLBRILLER = 'solbriller',
    FERDIG = 'ferdig',
    DOKUMENT = 'dokument',
    TIMEGLASS2 = 'timeglass2',
}

export enum Jul {
    JULEKULE = 'julekule',
    JULENISSE = 'julenisse',
    JULESTRØMPE = 'julestrompe',
    REINSDYR = 'reinsdyr',
}

export type PictogramNameType =
    | BankOgSparing
    | Bygninger
    | Dyr
    | HelseOgForsikring
    | Kjøretøy
    | Kommunikasjon
    | MatOgDrikke
    | Medlem
    | Navigasjon
    | Status
    | Verktøy
    | Annet
    | Jul;

export const PictogramName = {
    BANK_OG_SPARING: BankOgSparing,
    BYGNINGER: Bygninger,
    DYR: Dyr,
    HELSE_OG_FORSIKRING: HelseOgForsikring,
    KJØRETØY: Kjøretøy,
    KOMMUNIKASJON: Kommunikasjon,
    LAERING: Laering,
    MAT_OG_DRIKKE: MatOgDrikke,
    MEDLEM: Medlem,
    NAVIGASJON: Navigasjon,
    STATUS: Status,
    VERKTØY: Verktøy,
    ANNET: Annet,
    JUL: Jul,
};

export const pictogramNamesArray: Array<PictogramNameType> = Object.values(
    PictogramName,
).reduce((acc, category) => {
    const names = Object.values(category);
    return [...acc, ...names];
}, []);

export enum SoMeIconName {
    SOME_FACEBOOK = 'facebook',

    SOME_INSTAGRAM = 'instagram',

    SOME_TWITTER = 'twitter',

    SOME_LINKEDIN = 'linkedin',

    SOME_EMAIL = 'email',

    SOME_VIMEO = 'vimeo',

    SOME_YOUTUBE = 'youtube',
}

export enum MenuIconName {
    CHAT = 'chat',

    DOKUMENTER = 'dokumenter',

    GRAF = 'graf',

    HJEM = 'hjem',

    KJERLIGHET = 'kjærlighet',

    KORT = 'kort',

    PARAPLY = 'paraply',

    PERSON = 'person',

    PLASTER = 'plaster',

    SPAREGRIS = 'sparegris',
}
